import { newToast } from '../components';
import useApi from '../utils/axios-pettitions';
import { useAppDispatch } from '../contexts/hooks';
import { setMode } from '../contexts/slices/quotations';

export const useApiQuotation = () => {
  const { runApi } = useApi();
  const dispatch = useAppDispatch();

  const NewQuotation = async (data: any) => {
    return runApi('Quotation/Create', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        dispatch(setMode({ mode: 'view', idQuotation: res.data.Cz_Id }));
        return res.data;
      }
      return [];
    });
  };

  const GetById = async (idQuotation) => {    
    return runApi('Quotation/GetById', 'GET', {idQuotation}, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return null;
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return null;
    });
  };


  const GetByFilter = async (inicio: string, fin: string) => {
    return runApi('Quotation/GetByFilter', 'GET', { inicio, fin }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const deleteQuotation = async (idQuotation: number) => {
    return runApi('Quotation/Delete', 'POST', { idQuotation }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  const EditQuotation = async (data: any, idQuotation: number) => {
    return runApi('Quotation/Edit', 'POST', { idQuotation }, data).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        dispatch(setMode({ mode: 'view', idQuotation }));
        return res.data;
      }
      return [];
    });
  };

  return {
    NewQuotation,
    GetById,
    GetByFilter,
    deleteQuotation,
    EditQuotation,
  };
};
